import { Menu } from "antd";
import { BiLogOut } from "react-icons/bi";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { roles } from "../../config/roles";
// import { login } from "../../store/reducers/AuthSlice";
import useWindowDimensions from "../../hooks/useWindowDimensions";
// import { checkRouteName } from "../../utills";
import { checkRouteName } from "../../utills";
import Storage from "../../utills/AsyncStorage";
import TextComponent from "../textComponent/TextComponent";
import "./sideMenu.css";
import { AuthMiddleware } from "../../Store/Middlewares/AuthMiddleware";
import { getUser, isLogin } from "../../Store/Actions/AuthAction";
import { sessionExpired } from "../../Store/Actions/GeneralActions";
import { MdOutlineAccessTimeFilled } from "react-icons/md";
import { RiUserShared2Fill, RiUserSharedFill } from "react-icons/ri";
import { FaSplotch } from "react-icons/fa";

const menuStyle = {
  borderRadius: 0,
  width: "100%",
  margin: 0,
  paddingLeft: 0,
  borderTopLeftRadius: "0px",
  borderBottomLeftRadius: "0px",
  marginBottom: 5,
  fontFamily: "var(--font-family)",
};

const dealershipMenu = (navigation) => {
  return [
    {
      style: menuStyle,
      key: "dashboard",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/home.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">Home</h4>,
      onClick: () => {
        navigation("dashboard");
      },
    },
    {
      style: menuStyle,
      key: "inventory",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/inventory.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">Device Inventory</h4>,
      onClick: () => {
        navigation("inventory");
      },
    },
    {
      style: menuStyle,
      key: "assets",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/assets.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">Vehicle Inventory</h4>,
      onClick: () => {
        navigation("assets");
      },
    },
    // {
    //   style: menuStyle,
    //   key: "loRaWanControl",
    //   icon: (
    //     <img
    //       className="sidebarIcon"
    //       src={require("../../assets/images/sidebarIcons/inventory.png")}
    //       alt=""
    //     />
    //   ),
    //   label: <h4 className="menu-lable">LoRa WAN Control</h4>,
    //   onClick: () => {
    //     navigation("loRaWanControl");
    //   },
    // },
    // {
    //   style: menuStyle,
    //   key: "products",
    //   icon: (
    //     <img
    //       className="sidebarIcon"
    //       src={require("../../assets/images/sidebarIcons/order.png")}
    //       alt=""
    //     />
    //   ),
    //   label: <h4 className="menu-lable">Order Management</h4>,
    //   onClick: () => {
    //     navigation("/products");
    //   },
    // },
    {
      style: menuStyle,
      key: "reports",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/report.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">Reports</h4>,
      onClick: () => {
        navigation("/reports");
      },
    },
    {
      style: menuStyle,
      key: "lisenceManagement",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/liscence.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">License management</h4>,
      onClick: () => {
        navigation("/lisenceManagement");
      },
    },
    {
      style: menuStyle,
      key: "lot-name",
      icon: <FaSplotch color="white" className="sidebarIcon" />,
      label: <h4 className="menu-lable">Lot Name</h4>,
      onClick: () => {
        navigation("/lot-name");
      },
    },
    {
      style: menuStyle,
      key: "businessProfile",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/business.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">Admin Setting</h4>,
      onClick: () => {
        navigation("/businessProfile");
      },
    },
    // {
    //   style: menuStyle,
    //   key: "Staff",
    //   icon: (
    //     // <img
    //     <GrUserWorker color="var(--white-color)" size={20} style={{marginLeft: "9px"}}/>
    //     //   className="sidebarIcon"
    //     //   src={require("../../assets/images/sidebarIcons/order.png")}
    //     //   alt=""
    //     // />
    //   ),
    //   label: <h4 className="menu-lable">Staff Management</h4>,
    //   onClick: () => {
    //     navigation("/products");
    //   },
    // },
    {
      style: menuStyle,
      key: "accountSettings",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/settings.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">Account Settings</h4>,
      onClick: () => {
        navigation("/accountSettings");
      },
    },
    {
      style: menuStyle,
      key: "shared-access",
      icon: <RiUserSharedFill color="white" className="sidebarIcon" />,
      label: <h4 className="menu-lable">Shared Access</h4>,
      onClick: () => {
        navigation("/shared-access");
      },
    },
    {
      style: menuStyle,
      key: "activity-logs",
      icon: <MdOutlineAccessTimeFilled color="white" className="sidebarIcon" />,
      label: <h4 className="menu-lable">Activity Logs</h4>,
      onClick: () => {
        navigation("/activity-logs");
      },
    },
    {
      style: menuStyle,
      key: "helpSupport",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/support.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">Help & Support</h4>,
      onClick: () => {
        navigation("/helpSupport");
      },
    },
    {
      style: menuStyle,
      key: "faq",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/faq.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">FAQ</h4>,
      onClick: () => {
        navigation("/faq");
      },
    },

    {
      style: menuStyle,
      key: "terms&condition",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/terms.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">Terms and Conditions</h4>,
      onClick: () => {
        navigation("/terms&conditions");
      },
    },
    {
      style: menuStyle,
      key: "privacyPolicy",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/privacy.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">Privacy Policy</h4>,
      onClick: () => {
        navigation("/privacyPolicy");
      },
    },
  ];
};
const dealershipStaffMenu = (navigation, user) => {
  const is_immobilized = user?.permissions?.find(
    (x) => x?.name == "action_for_immobilizer",
  );
  const add_asset = user?.permissions?.find((x) => x?.name == "add_asset");
  const sold_history = user?.permissions?.find(
    (x) => x?.name == "sold_history",
  );
  const temporary_access = user?.permissions?.find(
    (x) => x?.name == "temporary_access",
  );
  const sell_through = user?.permissions?.find(
    (x) => x?.name == "sell_through",
  );
  const reports = user?.permissions?.find((x) => x?.name == "reports");
  const Staff_Creation = user?.permissions?.find(
    (x) => x?.name == "staff_creation",
  );
  const lot_name = user?.permissions?.find((x) => x?.name == "lot_name");

  return [
    {
      style: menuStyle,
      key: "dashboard",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/home.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">Home</h4>,
      onClick: () => {
        navigation("dashboard");
      },
    },
    {
      style: menuStyle,
      key: "inventory",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/inventory.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">Device Inventory</h4>,
      onClick: () => {
        navigation("inventory");
      },
    },
    // add_asset?.is_access == 1 || is_immobilized?.is_access == 1 ?
    {
      style: menuStyle,
      key: "assets",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/assets.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">Vehicle Inventory</h4>,
      onClick: () => {
        navigation("assets");
      },
    },
    // : null,

    // {
    //   style: menuStyle,
    //   key: "loRaWanControl",
    //   icon: (
    //     <img
    //       className="sidebarIcon"
    //       src={require("../../assets/images/sidebarIcons/inventory.png")}
    //       alt=""
    //     />
    //   ),
    //   label: <h4 className="menu-lable">LoRa WAN Control</h4>,
    //   onClick: () => {
    //     navigation("loRaWanControl");
    //   },
    // },
    // {
    //   style: menuStyle,
    //   key: "products",
    //   icon: (
    //     <img
    //       className="sidebarIcon"
    //       src={require("../../assets/images/sidebarIcons/order.png")}
    //       alt=""
    //     />
    //   ),
    //   label: <h4 className="menu-lable">Order Management</h4>,
    //   onClick: () => {
    //     navigation("/products");
    //   },
    // },
    reports?.is_access == 1
      ? {
          style: menuStyle,
          key: "reports",
          icon: (
            <img
              className="sidebarIcon"
              src={require("../../assets/images/sidebarIcons/report.png")}
              alt=""
            />
          ),
          label: <h4 className="menu-lable">Reports</h4>,
          onClick: () => {
            navigation("/reports");
          },
        }
      : null,
    {
      style: menuStyle,
      key: "lisenceManagement",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/liscence.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">License management</h4>,
      onClick: () => {
        navigation("/lisenceManagement");
      },
    },

    {
      style: menuStyle,
      key: "accountSettings",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/settings.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">Account Settings</h4>,
      onClick: () => {
        navigation("/accountSettings");
      },
    },
    Staff_Creation?.is_access == 1
      ? {
          style: menuStyle,
          key: "businessProfile",
          icon: (
            <img
              className="sidebarIcon"
              src={require("../../assets/images/sidebarIcons/business.png")}
              alt=""
            />
          ),
          label: <h4 className="menu-lable">Admin Setting</h4>,
          onClick: () => {
            navigation("/businessProfile");
          },
        }
      : null,
    temporary_access?.is_access == 1 || sell_through?.is_access == 1
      ? {
          style: menuStyle,
          key: "shared-access",
          icon: <RiUserSharedFill color="white" className="sidebarIcon" />,
          label: <h4 className="menu-lable">Shared Access</h4>,
          onClick: () => {
            navigation("/shared-access");
          },
        }
      : null,
    lot_name?.is_access == 1
      ? {
          style: menuStyle,
          key: "lot-name",
          icon: <FaSplotch color="white" className="sidebarIcon" />,
          label: <h4 className="menu-lable">Lot Name</h4>,
          onClick: () => {
            navigation("/lot-name");
          },
        }
      : null,
    Staff_Creation?.is_access == 1
      ? {
          style: menuStyle,
          key: "activity-logs",
          icon: (
            <MdOutlineAccessTimeFilled color="white" className="sidebarIcon" />
          ),
          label: <h4 className="menu-lable">Activity Logs</h4>,
          onClick: () => {
            navigation("/activity-logs");
          },
        }
      : null,
    {
      style: menuStyle,
      key: "helpSupport",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/support.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">Help & Support</h4>,
      onClick: () => {
        navigation("/helpSupport");
      },
    },
    {
      style: menuStyle,
      key: "faq",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/faq.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">FAQ</h4>,
      onClick: () => {
        navigation("/faq");
      },
    },

    {
      style: menuStyle,
      key: "terms&condition",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/terms.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">Terms and Conditions</h4>,
      onClick: () => {
        navigation("/terms&conditions");
      },
    },
    {
      style: menuStyle,
      key: "privacyPolicy",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/privacy.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">Privacy Policy</h4>,
      onClick: () => {
        navigation("/privacyPolicy");
      },
    },
  ];
};
const userMenu = (navigation) => {
  return [
    {
      style: menuStyle,
      key: "userDashboard",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/home.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">Home</h4>,
      onClick: () => {
        navigation("/userDashboard");
      },
    },
    {
      style: menuStyle,
      key: "module",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/home.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">Device</h4>,
      onClick: () => {
        navigation("/module");
      },
    },
    {
      style: menuStyle,
      key: "userAssets",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/userAsset.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">Vehicle</h4>,
      onClick: () => {
        navigation("/userAssets");
      },
    },
    {
      style: menuStyle,
      key: "accountSettings",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/profile.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">More</h4>,
      onClick: () => {
        navigation("/accountSettings");
      },
    },
    {
      style: menuStyle,
      key: "helpSupport",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/support.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">Help & Support</h4>,
      onClick: () => {
        navigation("/helpSupport");
      },
    },
    {
      style: menuStyle,
      key: "faq",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/faq.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">FAQ</h4>,
      onClick: () => {
        navigation("/faq");
      },
    },
    {
      style: menuStyle,
      key: "terms&condition",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/terms.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">Terms and Conditions</h4>,
      onClick: () => {
        navigation("/terms&conditions");
      },
    },
    {
      style: menuStyle,
      key: "privacyPolicy",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/privacy.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">Privacy Policy</h4>,
      onClick: () => {
        navigation("/privacyPolicy");
      },
    },
  ];
};
const companyMenu = (navigation) => {
  return [
    {
      style: menuStyle,
      key: "Customers",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/home.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">Customers</h4>,
      onClick: () => {
        navigation("/customers");
      },
    },
    {
      style: menuStyle,
      key: "Dealership",
      icon: (
        <img
          className="sidebarIcon"
          src={require("../../assets/images/sidebarIcons/home.png")}
          alt=""
        />
      ),
      label: <h4 className="menu-lable">Dealerships</h4>,
      onClick: () => {
        navigation("/dealerships");
      },
    },
  ];
};

const SideMenu = ({ collapsed, onBackClick }) => {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const location = useLocation();
  const navigate = useNavigate();
  const user = useSelector((state) => state.AuthReducer.user);

  const { height, width } = useWindowDimensions();
  // const role = localStorage.getItem("@role");
  const role = Storage.getERole("@role");

  const menus =
    role == roles.dealership && user?.is_owner
      ? dealershipMenu(navigation)
      : role == roles.user
        ? userMenu(navigation)
        : role == roles.company
          ? companyMenu(navigation)
          : dealershipStaffMenu(navigation, user);

  const onLogout = () => {
    dispatch(AuthMiddleware.logout()).then((data) => {
      dispatch(getUser(null));
      dispatch(isLogin(false));
      dispatch(sessionExpired(false));
      localStorage.clear();
      navigate("/");
    });
  };

  return (
    <div className="menu-main-container">
      <div className="logo_container">
        {collapsed ? (
          <img
            src={require("../../assets/images/sideMenuLogo.png")}
            alt="logo"
            style={{ width: "50%", height: "50%" }}
          />
        ) : (
          <img
            src={require("../../assets/images/sideMenuLogo.png")}
            alt="logo"
            style={{ width: "70%", height: "70%" }}
          />
        )}
      </div>
      <Menu
        _internalDisableMenuItemTitleTooltip
        className={`${collapsed ? "menu-colapsed" : "menu"}`}
        mode="inline"
        defaultSelectedKeys={checkRouteName(location.pathname?.substring(1))}
        selectedKeys={checkRouteName(location.pathname?.substring(1))}
        items={menus}
      />
      <div className="logout-cont" onClick={onLogout}>
        <BiLogOut color="var(--white-color)" size={20} />
        <TextComponent
          style={{
            fontFamily: "Urbanist-semibold",
            color: "var(--white-color)",
            marginLeft: "10px",
          }}
          text={"Logout"}
        />
      </div>
    </div>
  );
};

export default SideMenu;
